declare const sgSettings: any;

export function getPublisherId(): string {
  try {
    return sgSettings.config.publisher.id;
  } catch (e) {
    return 'unknown';
  }
}
